export default __webpack_public_path__ + "static/media/NIS.ba606ebd.jpg";